import i18n from '../i18n';

/** Enum translations for backend values that don't have _ro/_en fields */
const ENUM_RO: Record<string, string> = {
  // Verdict / Risk category
  DISINFORMATION: 'Dezinformare',
  UNRELIABLE: 'Nedemn de încredere',
  QUESTIONABLE: 'Îndoielnic',
  UNCERTAIN: 'Incert',
  MIXED: 'Mixt',
  MOSTLY_TRUSTWORTHY: 'Preponderent credibil',
  MOSTLY_RELIABLE: 'Preponderent credibil',
  TRUSTWORTHY: 'Demn de încredere',
  RELIABLE: 'De încredere',
  INCONCLUSIVE: 'Neconcludent',
  // Risk level / Severity
  CRITICAL: 'Critic',
  VERY_HIGH: 'Foarte ridicat',
  HIGH: 'Ridicat',
  MODERATE: 'Moderat',
  MEDIUM: 'Mediu',
  LOW: 'Scăzut',
  VERY_LOW: 'Foarte scăzut',
  // AI verdict
  LIKELY_AI: 'Probabil AI',
  POSSIBLY_AI: 'Posibil AI',
  UNLIKELY_AI: 'Improbabil AI',
  POSSIBLY_HUMAN: 'Posibil uman',
  LIKELY_HUMAN: 'Probabil uman',
  HUMAN: 'Uman',
  // Source verdict
  TRUSTED: 'De încredere',
  NEUTRAL: 'Neutru',
  SUSPICIOUS: 'Suspect',
  UNTRUSTED: 'Nedemn de încredere',
  // Stance
  SUPPORTS: 'Susține',
  CONTRADICTS: 'Contrazice',
  // Reliability
  official: 'Oficial',
  news: 'Știri',
  blog: 'Blog',
  unknown: 'Necunoscut',
  // Recommended actions
  NONE: 'Niciuna',
  CAUTION: 'Precauție',
  WARNING: 'Avertizare',
  URGENT: 'Urgent',
  ESCALATE: 'Escaladează',
  // Virality
  VIRAL: 'Viral',
};

/**
 * Translate a backend enum value based on current i18n language.
 * RO → looks up in ENUM_RO map, EN → returns original value.
 */
export function enumLabel(value: string | null | undefined): string {
  if (!value) return '';
  const isRo = i18n.language?.startsWith('ro');
  if (isRo && ENUM_RO[value]) return ENUM_RO[value];
  return value;
}
